import React from 'react';
import { LayoutDashboard, Package, ShoppingCart, ArrowDownToLine, Users, Wallet, Settings, LogOut, MessageSquare } from 'lucide-react';
import { useAdmin } from '../../context/AdminContext';
import Logo from '../../components/Logo';

const NAV = [
  { id: 'dashboard', label: 'Dashboard', icon: LayoutDashboard },
  { id: 'orders', label: 'Orders', icon: ShoppingCart },
  { id: 'deposits', label: 'Deposits', icon: ArrowDownToLine },
  { id: 'support', label: 'Support', icon: MessageSquare },
  { id: 'products', label: 'Products', icon: Package },
  { id: 'users', label: 'Users', icon: Users },
  { id: 'payments', label: 'Payment Methods', icon: Wallet },
  { id: 'settings', label: 'Settings', icon: Settings },
];

const AdminSidebar = ({ page, setPage }) => {
  const { logout, orders, deposits, supportUnread } = useAdmin();
  const pendingOrders = orders.filter((o) => o.status === 'PENDING').length;
  const pendingDeposits = deposits.filter((d) => d.status === 'PENDING').length;

  const badgeFor = (id) => {
    if (id === 'orders' && pendingOrders > 0) return pendingOrders;
    if (id === 'deposits' && pendingDeposits > 0) return pendingDeposits;
    if (id === 'support' && supportUnread > 0) return supportUnread;
    return null;
  };

  return (
    <aside className="w-[240px] min-w-[240px] border-r border-[#151515] bg-[#080808] flex flex-col h-screen sticky top-0">
      <div className="px-4 pt-5 pb-6 flex items-center gap-2 whitespace-nowrap">
        <Logo size={18} textSize={11} />
        <span className="text-[#22c55e] text-[9px] tracking-[0.25em]">· ADMIN</span>
      </div>

      <nav className="flex-1">
        {NAV.map((n) => {
          const active = page === n.id;
          const badge = badgeFor(n.id);
          const Icon = n.icon;
          return (
            <button
              key={n.id}
              onClick={() => setPage(n.id)}
              className={`w-full text-left px-4 py-2.5 flex items-center justify-between text-[13px] transition-colors border-l-2 ${
                active ? 'text-[#22c55e] bg-[#0f1a12] border-[#22c55e]' : 'text-[#8a8a8a] hover:text-[#e6e6e6] border-transparent'
              }`}
            >
              <span className="flex items-center gap-2.5">
                <Icon size={14} />
                {n.label}
              </span>
              {badge && (
                <span className="text-[9px] px-1.5 py-0.5 rounded-full bg-[#22c55e] text-black font-semibold min-w-[18px] text-center">{badge}</span>
              )}
            </button>
          );
        })}
      </nav>

      <div className="px-4 py-4 border-t border-[#151515]">
        <a href="/" className="block text-[10px] tracking-[0.25em] text-[#5a5a5a] hover:text-[#22c55e] mb-3">← GO TO STORE</a>
        <button onClick={logout} className="w-full flex items-center gap-2 justify-center text-[11px] tracking-[0.2em] py-2 rounded-md border border-[#1f1f1f] text-[#8a8a8a] hover:border-[#ef4444] hover:text-[#ef4444] transition-colors">
          <LogOut size={12} /> LOGOUT
        </button>
      </div>
    </aside>
  );
};

export default AdminSidebar;
